import * as React from "react";
import { ButtonDropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { MORE_SVG, BPMMedia } from 'bpm-web-generic';


export interface BrowseDropDownItem {
    title: string;
    icon?: string
    onClick: (e: React.MouseEvent<HTMLElement>) => void
}

export interface BrowseDropDownListItem {
    title: string;
    items: BrowseDropDownItem[]
}

export class BrowseDropDown extends React.Component<{
    onDownload?: (media: BPMMedia) => void,
    onAddToQueue?: () => void,
    onAddToCrate?: () => void,
    style?: React.CSSProperties,
    items: (BrowseDropDownListItem | BrowseDropDownItem)[]
}, { isOpen: boolean }> {

    constructor(props: any) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        }
    }

    toggle() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    public render() {
        return <div className='browse-dropdown' style={this.props.style}>
            <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle} direction='down'>
                <DropdownToggle style={{ boxShadow: "none" }} color="themed" className='browse-dropdown-button' onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation()
                    e.preventDefault()
                }}>
                    <img style={{ width: 20 }} src={MORE_SVG} />
                </DropdownToggle>
                <DropdownMenu right={true} className='dropdown-menu'>
                    {this.props.items.map(item => {
                        if ('items' in item) {
                            return <DropdownDropDownItem key={item.title} items={item.items.map(item => {
                                return {
                                    ...item, onClick: (e: React.MouseEvent<HTMLElement>) => {
                                        item.onClick(e)
                                        this.toggle()
                                    }
                                }
                            })} title={item.title} />
                        } else {
                            return <DropdownListItem key={item.title}
                                {...item} className='hide-mobile'
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    item.onClick(e)
                                    this.toggle()
                                }} />
                        }
                    })}
                </DropdownMenu>
            </ButtonDropdown>
        </div>
    }
}


export interface DropdownListItemProps {
    title: string
    icon?: string
    onClick: (e: React.MouseEvent) => void
    className?: string
}

export class DropdownListItem extends React.Component<DropdownListItemProps, {}> {

    render() {
        return (
            <div
                key={this.props.title}
                className={"dropdown-item " + (this.props.className || '')} onClick={this.props.onClick}>
                <span style={{ marginLeft: '2px' }} className="dropdown-text">{this.props.title}</span>
            </div>
        )
    }
}

export interface DropdownDropDownItemProps {
    items: BrowseDropDownItem[]
    title: string;
    className?: string
}
export class DropdownDropDownItem extends React.Component<DropdownDropDownItemProps, { isOpen: boolean }> {

    constructor(props: any) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        }
    }

    toggle() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    render() {
        return (
            <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggle} direction='right' className={(this.props.className || '') + ' secondary-drop-down'}>

                <DropdownToggle style={{ boxShadow: "none" }} color="themed" onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation()
                    e.preventDefault()
                }}>
                    <div
                        className={"dropdown-item " + (this.props.className || '')}>
                        <span className="dropdown-text">{this.props.title}</span>
                    </div>
                </DropdownToggle>
                <DropdownMenu right={true} className='dropdown-menu'>
                    {this.props.items.map(item => {
                        return <DropdownListItem key={item.title}
                            {...item} className='hide-mobile'
                            onClick={(e: React.MouseEvent<HTMLElement>) => {
                                e.stopPropagation()
                                e.preventDefault()
                                item.onClick({ currentTarget: e.currentTarget.closest('.next-popup-container') } as any)
                                this.toggle()
                            }} />
                    })}
                </DropdownMenu>
            </ButtonDropdown>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BrowseDropDown.tsx